import { useParams } from 'react-router';
import Button from '@/components/UI/Button';
import Card from '@/components/UI/Card/index.tsx';
import Table from '@/features/ChangeOrder/Summary/Table';
import { mockProgramReports } from '@/features/projects/components/Reports/data';
import { useProject } from '@/hooks/ReactQueryHooks/useProjectQuery';
import { columns } from './columns';

export function ReportDetails() {
  const { reportId, projectId = '' } = useParams();
  const report = mockProgramReports.find((report) => String(report.id) === reportId);
  const project = useProject({ projectId: Number(projectId) });

  const title = project?.data?.data.name ? `${report?.name} for ${project?.data?.data.name}` : `${report?.name}`;

  return (
    <Card title={title} titleElement={<Button btnStyle='btn-primary' label='Generate' />}>
      <Table
        tableClassName='!w-full'
        cols={columns}
        data={[
          {
            id: 1,
            generatedBy: 'Marcus Thompson',
            notes:
              "This glass office building's reflective façade and clean lines offer a sleek, professional look. Large windows maximize natural light, creating an open, energy-efficient workspace ideal for modern businesses.",
            createdAt: '11/31/2024',
            downloadLink: mockProgramReports[0].fileUrl,
          },
        ]}
      />
    </Card>
  );
}
